import { render, staticRenderFns } from "./TrademarkAnalysis.vue?vue&type=template&id=a50e2340&"
import script from "./TrademarkAnalysis.vue?vue&type=script&lang=js&"
export * from "./TrademarkAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkAnalysis.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports